export const INELIGIBLE_ZIPS_8_28_2025: number[] = [
  95757, 92503, 95630, 11697, 95608, 95829, 95835, 95670, 95624, 92506, 95833,
  95742, 95843, 95621, 92504, 95823, 95838, 95822, 34474, 92507, 95831, 95834,
  95660, 95758, 95610, 95351, 95632, 95832, 95828, 34293, 95816, 95815, 95747,
  77365, 77535, 95841, 95864, 34473, 1054, 11548, 75068, 77070, 94926, 77373,
  10923, 91320, 90046, 95123, 93065, 12866, 93460, 12468, 34762, 20736, 8053,
  91361, 93013, 91108, 33050, 2835, 92582, 92377, 92586, 78613, 10314, 3217,
  78628, 7827, 11514, 78254, 95826, 95148, 91360, 94306, 21861, 78640, 92317,
  95842, 95695, 95348, 92562, 77429, 21629, 34639, 79703, 95746, 78148, 95683,
  91104, 32571, 78645, 76226, 2043, 10457, 34769, 1235, 95818, 95821, 93654,
  33477, 1887, 60418, 33545, 34606, 92501, 1243, 75094, 92117, 94567, 77461,
  94501, 95817, 76539, 33803, 33810, 34420, 3855, 61884, 95827, 91320, 95340,
  92008, 34753, 92131, 3885, 91011, 95831, 78757, 76016, 32828, 95363, 78758,
  76052, 14220,
];
